import CompetitorsTask from "@/components/competitors/task/Task";
import ArchiveList from "@/components/competitors/archiveList/ArchiveList";
import CompetitorList from "@/components/competitors/list/List";
import TaskList from "@/components/competitors/taskList/TaskList";
import ViewTask from "@/components/competitors/viewTask/ViewTask";

export const competitors = [
    {path: '/competitors/task', name: 'competitors', component: CompetitorsTask},
    {path: '/competitors/task-list', name: 'competitorsTaskList', component: TaskList},
    {path: '/competitors/archive-list', name: 'competitorsArchiveList', component: ArchiveList},
    {path: '/competitors/list', name: 'competitorList', component: CompetitorList},
    {path: '/competitors/view-task/:id', name: 'competitorsViewTask', component: ViewTask},
]